import { Component } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { toastSlide } from '../../animations';

@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  animations: [toastSlide]
})
export class ToastComponent {
  constructor(public readonly toastService: ToastService) {}
}
